import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionsComponent } from './options.component';



@NgModule({
  declarations: [
    OptionsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OptionsComponent
  ]
})
export class OptionsMenuModule { }
